/* APW "Color Dots" — BYO pouch picker controller.
   Sibling-switcher contract:
   - all state resolved from the LIVE DOM at event time, never captured across swaps
   - init keyed off 'soolla:product-swapped', idempotent via dataset.apwBound
   - nodes inside [data-sibsw-stage] are never touched (no fetches, no GA4, no cart)
   - a colourway switch resets the pick to the new colour's matching default by design
   Draft 1: a swapped (non-matching) pick BLOCKS add-to-cart with a toast; the
   market-price Discount Function ships separately. Matching selection leaves the
   existing bundle interceptor path completely untouched. */
(function () {
  'use strict';
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function ga(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {} }
  function pub(name, data) { try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('soolla:' + name, data); } catch (e) {} }

  function toast(msg) {
    var t = document.querySelector('.apw-toast');
    if (!t) { t = document.createElement('div'); t.className = 'apw-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t.__tm);
    t.__tm = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ATC price text swap for SOLO pages only (the premade widget's own
     controller does this on bundle pages) — same token pattern it uses */
  function setAtcPrice(fs, money) {
    if (!money) return;
    var root = fs.closest('product-information[data-section]');
    if (!root || root.closest('[data-sibsw-stage]')) return;
    var priceToken = /(?:[A-Z]{1,3})?[\u20ac\u00a3$]\s?[\d.,]+(?:\s+[A-Z]{3})?/;
    root.querySelectorAll('.product-form__buy-buttons button, .product-form__submit, [name="add"]').forEach(function (btn) {
      var spans = btn.querySelectorAll('[data-add-to-cart-price]'), wlk = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), n;
      /* the label's own price span works in any currency; the token below only knows the euro, pound and dollar signs */ if (spans.length) { spans.forEach(function (el) { el.textContent = money; }); return; } while ((n = wlk.nextNode())) { if (priceToken.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(priceToken, money); break; } }
    });
    var sp = document.querySelector('[data-sticky-price], [data-pdpv2-sticky-price]');
    if (sp) sp.textContent = money;
  }

  /* live fieldset only — canonical scoping per the sibling switcher
     (sibling-switcher.js:63-79): root = first non-staged
     product-information[data-section]; never a document-wide id lookup. */
  function liveFs() {
    var roots = document.querySelectorAll('product-information[data-section]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].closest('[data-sibsw-stage]')) continue;
      var fs = roots[i].querySelector('[data-bndl], [data-apw-solo]');
      if (fs) return fs;
    }
    var all = document.querySelectorAll('[data-bndl], [data-apw-solo]');
    for (var j = 0; j < all.length; j++) {
      if (!all[j].closest('[data-sibsw-stage]')) return all[j];
    }
    return null;
  }

  /* conveyor: C1-TAP-ADVANCE mechanics (tap near an edge advances the belt) */
  function conveyor(container, onPick) {
    var vp = container.querySelector('.apwv-viewport');
    var track = container.querySelector('.apwv-track');
    if (!vp || !track) return null;
    var animating = false, dragOff = 0, suppressClick = false;
    function slotW() { var k = track.children[0]; if (!k) return 55; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 10); return k.getBoundingClientRect().width + gap; }
    function setX(x, anim) { track.classList.toggle('is-anim', !!anim && !reduced); track.style.transform = 'translateX(' + x + 'px)'; }
    function normalizeFwd(n) { for (var i = 0; i < n; i++) track.appendChild(track.children[0]); setX(0, false); }
    function normalizeBack(n) { for (var i = 0; i < n; i++) track.insertBefore(track.children[track.children.length - 1], track.children[0]); }
    function advance(n, fromOff) {
      if (animating || !n) return; animating = true;
      var w = slotW(), start = (typeof fromOff === 'number') ? fromOff : 0;
      if (reduced) { if (n > 0) normalizeFwd(n); else { normalizeBack(-n); setX(0, false); } animating = false; return; }
      if (n > 0) {
        setX(start, false); void track.offsetWidth;
        setX(-n * w, true);
        var fin = false, tm;
        var done = function (e) { if (e && e.target !== track) return; if (fin) return; fin = true; clearTimeout(tm); track.removeEventListener('transitionend', done); normalizeFwd(n); animating = false; };
        track.addEventListener('transitionend', done);
        tm = setTimeout(done, 430);
      } else {
        var m = -n; normalizeBack(m);
        setX(-m * w + start, false); void track.offsetWidth;
        setX(0, true);
        var fin2 = false, tm2;
        var done2 = function (e) { if (e && e.target !== track) return; if (fin2) return; fin2 = true; clearTimeout(tm2); track.removeEventListener('transitionend', done2); track.classList.remove('is-anim'); animating = false; };
        track.addEventListener('transitionend', done2);
        tm2 = setTimeout(done2, 430);
      }
    }
    track.addEventListener('click', function (e) {
      var sw = e.target.closest('.apwv-sw'); if (!sw) return;
      if (suppressClick) { suppressClick = false; return; }
      track.querySelectorAll('.apwv-sw').forEach(function (s) { s.classList.remove('is-on'); });
      sw.classList.add('is-on');
      onPick(sw);
      var vr = vp.getBoundingClientRect(), sr = sw.getBoundingClientRect(), w1 = slotW();
      if (sr.right >= vr.right - w1 * 0.6) advance(1);
      else if (sr.left <= vr.left + w1 * 0.6) advance(-1);
    });
    track.addEventListener('keydown', function (e) {
      var sw = e.target.closest('.apwv-sw'); if (!sw) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sw.click(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); advance(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); advance(-1); }
    });
    var pv = container.querySelector('.apwv-nav--prev'), nx = container.querySelector('.apwv-nav--next');
    if (pv) pv.addEventListener('click', function (e) { e.preventDefault(); advance(-1); });
    if (nx) nx.addEventListener('click', function (e) { e.preventDefault(); advance(1); });
    var acc = 0;
    vp.addEventListener('wheel', function (e) {
      var dx = e.deltaX, dy = e.deltaY;
      var horiz = Math.abs(dx) > Math.abs(dy) || e.shiftKey;
      if (!horiz) return;
      e.preventDefault();
      acc += (Math.abs(dx) > Math.abs(dy) ? dx : dy);
      if (Math.abs(acc) > 28 && !animating) { advance(acc > 0 ? 1 : -1); acc = 0; }
    }, { passive: false });
    var px = 0, py = 0, dragging = false, horizLock = false;
    vp.addEventListener('pointerdown', function (e) {
      if (animating) return;
      dragging = true; horizLock = false; px = e.clientX; py = e.clientY; dragOff = 0;
      vp.classList.add('is-drag');
    });
    vp.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - px, dy = e.clientY - py;
      if (!horizLock) { if (Math.abs(dx) < 6) return; if (Math.abs(dy) > Math.abs(dx)) { dragging = false; vp.classList.remove('is-drag'); return; } horizLock = true; try { vp.setPointerCapture(e.pointerId); } catch (err) {} }
      dragOff = dx; setX(dragOff, false);
    });
    function endDrag() {
      if (!dragging) return; dragging = false; vp.classList.remove('is-drag');
      if (!horizLock) { dragOff = 0; return; }
      suppressClick = Math.abs(dragOff) > 8;
      var w = slotW(); var n = Math.round(-dragOff / w);
      var max = track.children.length - 1; if (n > max) n = max; if (n < -max) n = -max;
      if (n === 0) { setX(0, true); var d = function () { track.removeEventListener('transitionend', d); track.classList.remove('is-anim'); }; track.addEventListener('transitionend', d); }
      else advance(n, dragOff);
      dragOff = 0;
      setTimeout(function () { suppressClick = false; }, 350);
    }
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    return { selectByName: function (name) { track.querySelectorAll('.apwv-sw').forEach(function (s) { s.classList.toggle('is-on', s.dataset.name === name); }); } };
  }

  /* byo mode must also kill dynamic checkout (Shop Pay would submit the form's
     single variant straight to checkout — bag alone at full price). The theme's
     product-form.js REMOVES its own --disable class on a wrapper click, so that
     class is useless here: we hide the wrapper outright with our own class AND
     guard it with a capture-phase click blocker that re-checks live state.
     Live section only, never the staged copy's. */
  function syncDynamicButtons(fs) {
    var root = fs.closest('product-information[data-section]');
    if (!root || root.closest('[data-sibsw-stage]')) return;
    var wrap = root.querySelector('.product-form__dynamic-buttons');
    if (!wrap) return;
    if (wrap.dataset.apwGuarded !== '1') {
      wrap.dataset.apwGuarded = '1';
      wrap.addEventListener('click', function (e) {
        var live = liveFs();
        if (live && live.dataset.selected === 'bundle' && (live.dataset.apwMode === 'byo' || live.hasAttribute('data-apw-solo'))) {
          e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
          toast('Mixed sets check out from your cart — add the set first.');
        }
      }, true);
    }
    /* same stale-read hazard as the change listener: read the radio, not fs.dataset.selected */
    var setRadio = fs.querySelector('input[type="radio"][value="bundle"]');
    /* solo pages: the set tile has no valid single-variant purchase even before a
       pouch is picked, so dynamic checkout hides on ANY set selection there */
    var byo = (fs.dataset.apwMode === 'byo' || fs.hasAttribute('data-apw-solo')) && !!(setRadio && setRadio.checked);
    wrap.classList.toggle('apw-dyn-off', byo);
  }

  function init(event) {
    var fs = liveFs();
    if (!fs) return;
    var dots = fs.querySelector('[data-apw-dots]');
    if (!dots) return; /* bundle-less bag or widget not rendered here */
    if (fs.dataset.apwBound === '1') return;
    fs.dataset.apwBound = '1';

    var cw = dots.getAttribute('data-apw-cw') || '';
    var card = fs.querySelector('[data-apw-card]');
    var railw = fs.querySelector('[data-apw-rail]');
    /* pouch data is rendered once from theme.liquid (outside every section) so it
       never rides a switcher re-render; fall back to an in-section copy if absent */
    var jsonEl = null;
    var jsonCandidates = document.querySelectorAll('script[data-apw-pouches]');
    for (var jc = 0; jc < jsonCandidates.length; jc++) {
      if (!jsonCandidates[jc].closest('[data-sibsw-stage]')) { jsonEl = jsonCandidates[jc]; break; }
    }
    var deal = card ? card.querySelector('.bndl__opt--deal') : null;
    if (!card || !railw || !deal) return;
    var nameEl = deal.querySelector('.bndl__name');
    var subEl = deal.querySelector('.bndl__sub');
    var thumb = deal.querySelector('.bndl__media img');
    var nameDefault = nameEl ? nameEl.textContent : '';
    var subDefault = subEl ? subEl.textContent : '';
    var thumbDefault = thumb ? thumb.src : '';
    /* solo = bag colourway with no premade bundle: BYO-only tile, origin no_match,
       no matching default, and this script owns selection state + ATC price text
       (the CPI bundle controller does not exist on these pages) */
    var solo = fs.hasAttribute('data-apw-solo');
    var origin = solo ? 'no_match' : 'had_match';
    fs.dataset.apwOrigin = origin;
    var colorway = fs.getAttribute('data-apw-bag') || (fs.getAttribute('data-bundle-sku') || '').replace(/^BUNDLE_/, '');
    var currency = fs.getAttribute('data-currency') || 'USD';
    var priceValue = Number(fs.getAttribute('data-bundle-price-value') || fs.getAttribute('data-set-price-value')) || 0;
    var conv = null, railBuilt = false;

    function gaP(extra) {
      var p = { widget: 'byo', origin: origin, bag_colorway: colorway, currency: currency, value: priceValue };
      for (var k in extra) p[k] = extra[k];
      return p;
    }
    function pop(src) {
      if (!thumb) return;
      thumb.classList.remove('apw-thumb-pop'); thumb.src = src; void thumb.offsetWidth; thumb.classList.add('apw-thumb-pop');
      var fin = false, tm; var done = function () { if (fin) return; fin = true; clearTimeout(tm); thumb.classList.remove('apw-thumb-pop'); thumb.removeEventListener('animationend', done); };
      thumb.addEventListener('animationend', done); tm = setTimeout(done, 520);
    }
    function markDots(n) {
      dots.querySelectorAll('.apw-dot').forEach(function (d) { d.classList.toggle('is-on', d.dataset.name === n); });
    }
    function selectSetTile() {
      var si = deal.querySelector('input[type="radio"]');
      if (si && !si.checked) { si.checked = true; si.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    /* solo pages own their selection state end-to-end: the pre-applied radio
       never fires a change event, so everything derives from the radio directly */
    function applySoloSelection() {
      var srb = fs.querySelector('input[type="radio"][value="bundle"]');
      var on = !!(srb && srb.checked);
      fs.dataset.selected = on ? 'bundle' : 'bag';
      fs.querySelectorAll('.bndl__opt').forEach(function (op) { var i2 = op.querySelector('input'); op.classList.toggle('is-selected', !!(i2 && i2.checked)); });
      card.classList.toggle('is-selected', on);
      if (on) { buildRail(); railw.classList.add('is-open'); } else { railw.classList.remove('is-open'); }
      setAtcPrice(fs, on ? fs.getAttribute('data-set-price') : fs.getAttribute('data-bag-price'));
      syncDynamicButtons(fs);
    }
    function applySetSelection() {
      if (solo) {
        var srb = fs.querySelector('input[type="radio"][value="bundle"]');
        if (srb && !srb.checked) srb.checked = true;
        applySoloSelection();
      } else {
        selectSetTile();
      }
    }
    function buildRail() {
      if (railBuilt || !jsonEl) return;
      railBuilt = true;
      var list = [];
      try { list = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var track = railw.querySelector('[data-apw-track]');
      list.forEach(function (p) {
        var img = document.createElement('img');
        img.className = 'apwv-sw' + (p.n === cw ? ' is-on' : '');
        img.tabIndex = 0; img.setAttribute('role', 'button');
        img.src = p.i; img.alt = 'Studio Pouch, ' + p.n;
        img.dataset.name = p.n; img.dataset.img = p.g; img.dataset.variant = p.v;
        track.appendChild(img);
      });
      conv = conveyor(railw.querySelector('.apwv-car'), function (sw) { pick(sw.dataset.name, sw.dataset.img, sw.dataset.variant, 'rail'); });
    }
    function pick(n, img, variantId, via, silent, noSelect) {
      var isMatch = n === cw;
      fs.dataset.apwMode = isMatch ? 'match' : 'byo';
      fs.dataset.apwPouch = n;
      fs.dataset.apwPouchVariant = variantId || '';
      card.classList.toggle('is-mixed', !isMatch);
      pop(img); markDots(n);
      if (conv) conv.selectByName(n);
      if (nameEl) nameEl.textContent = isMatch ? nameDefault : 'Bag + ' + n + ' pouch';
      if (subEl) subEl.textContent = isMatch ? subDefault : 'Swapped in. Same deal.';
      if (!noSelect) applySetSelection();
      syncDynamicButtons(fs);
      if (!silent) {
        ga('apw_pick', gaP({ pouch_colorway: n, via: via, swapped: !isMatch }));
        pub('apw_pick', gaP({ pouch_colorway: n, via: via, swapped: !isMatch }));
      }
    }
    function reset() {
      fs.dataset.apwMode = 'match'; fs.dataset.apwPouch = cw; fs.dataset.apwPouchVariant = '';
      card.classList.remove('is-mixed');
      if (thumb && thumbDefault) pop(thumbDefault);
      markDots(cw);
      if (conv) conv.selectByName(cw);
      if (nameEl) nameEl.textContent = nameDefault;
      if (subEl) subEl.textContent = subDefault;
      railw.classList.remove('is-open');
      syncDynamicButtons(fs);
      ga('apw_back', gaP({}));
    }

    fs.dataset.apwMode = 'match'; fs.dataset.apwPouch = cw;

    /* a pouch picked before a colourway switch survives it (preservedState.apw,
       captured by the switcher at commit); silently re-applied when that pouch
       exists on the new bag, else the new bag's match stands */
    var pres = event && event.detail && event.detail.preservedState;
    if (pres && pres.apw && pres.apw.mode === 'byo' && pres.apw.pouch && pres.apw.pouch !== cw && jsonEl) {
      try {
        var plist = JSON.parse(jsonEl.textContent);
        var pe = plist.find(function (p) { return p.n === pres.apw.pouch; });
        if (pe) pick(pe.n, pe.g, pe.v, 'preserved', true, pres.bundleSelection !== 'bundle');
      } catch (e) {}
    }

    dots.querySelectorAll('.apw-dot').forEach(function (d) {
      d.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        pick(d.dataset.name, d.dataset.img, d.dataset.variant, 'dot');
      });
    });
    var more = dots.querySelector('[data-apw-more]');
    if (more) more.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      buildRail();
      var open = railw.classList.toggle('is-open');
      selectSetTile();
      if (open) { ga('apw_rail_open', gaP({})); pub('apw_rail_open', gaP({})); }
    });
    var back = fs.querySelector('[data-apw-back]');
    if (back) back.addEventListener('click', function (e) { e.preventDefault(); reset(); });

    /* selecting "just the bag" collapses the rail; card highlight follows the deal tile */
    fs.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      /* read the radio itself: this listener can run BEFORE the section's own
         bundle script has updated fs.dataset.selected (registration order), so
         the dataset is stale for the click that goes back to "just the bag" and
         the card kept its red outline next to the selected bag tile */
      var bundleRadio = fs.querySelector('input[type="radio"][value="bundle"]');
      var isBundle = !!(bundleRadio && bundleRadio.checked);
      card.classList.toggle('is-selected', isBundle);
      if (solo) applySoloSelection();
      /* choosing the set expands the pouch selector (Andy 2026-09-26);
         "+N" stays a toggle, selecting the bag collapses it */
      if (isBundle) { buildRail(); railw.classList.add('is-open'); }
      else railw.classList.remove('is-open');
      syncDynamicButtons(fs);
    });
    if (solo) applySoloSelection();
    card.classList.toggle('is-selected', fs.dataset.selected === 'bundle');
    /* set tile already selected at init (preserved across a colourway switch):
       the rail shows for consistency with the tap-to-select behaviour */
    if (fs.dataset.selected === 'bundle') { buildRail(); railw.classList.add('is-open'); }
    syncDynamicButtons(fs);

    ga('apw_view', gaP({}));
    pub('apw_view', gaP({}));
  }

  /* the 2-line set add: bag + picked pouch in ONE /cart/add.js call, both lines
     stamped with the reserved properties the Discount Function keys on */
  var apwAddInFlight = false;
  function apwAdd(fs, form) {
    if (apwAddInFlight) return;
    apwAddInFlight = true;
    var setId = ''; try { setId = [...crypto.getRandomValues(new Uint8Array(6))].map(function (b) { return b.toString(16).padStart(2, '0'); }).join(''); } catch (e) { setId = String(Date.now()) + Math.floor(Math.random() * 1e6); }
    var colorway = fs.getAttribute('data-apw-bag') || (fs.getAttribute('data-bundle-sku') || '').replace(/^BUNDLE_/, '');
    var addOrigin = fs.dataset.apwOrigin || 'had_match';
    var props = {
      _bundle_source: 'apw_widget', _set_id: setId, _apw_origin: addOrigin,
      _apw_bag: colorway, _apw_pouch: fs.dataset.apwPouch || '',
    };
    var root = fs.closest('product-information[data-section]') || document;
    var btn = (form && form.querySelector && form.querySelector('button[type="submit"], [name="add"]')) || root.querySelector('.product-form__buy-buttons button');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); }
    var value = Number(fs.getAttribute('data-bundle-price-value') || fs.getAttribute('data-set-price-value')) || 0;
    var currency = fs.getAttribute('data-currency') || 'USD';
    var payload = { items: [
      { id: Number(fs.getAttribute('data-bag-variant')), quantity: 1, properties: props },
      { id: Number(fs.dataset.apwPouchVariant), quantity: 1, properties: props },
    ] };
    fetch(window.routes.cart_add_url + '.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || (window.cartStrings && window.cartStrings.error) || 'Add failed');
        return data;
      }); })
      .then(function () {
        (window.dataLayer = window.dataLayer || []).push({ event: 'add_to_cart', bundle: true, byo: true, set_id: setId });
        var p = { widget: 'byo', origin: addOrigin, value: value, currency: currency, bundle_colorway: colorway, pouch_colorway: fs.dataset.apwPouch || '', set_id: setId };
        ga('bundle_add', p); pub('bundle_add', p);
        try { if (typeof window.clarity === 'function') window.clarity('event', 'apw_byo_add'); } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        if (window.UpCart && typeof window.UpCart.open === 'function') { try { window.UpCart.open(); } catch (e2) {} }
        var upcartHost = document.getElementById('upCart');
        if (!upcartHost || !upcartHost.shadowRoot) window.location.assign(window.routes.cart_url);
      })
      .catch(function (error) {
        var pform = form && form.closest && form.closest('product-form');
        if (pform && typeof pform.handleErrorMessage === 'function') pform.handleErrorMessage(error.message);
        else { console.error(error); toast('Hmm, that didn’t add — try again?'); }
      })
      .finally(function () {
        apwAddInFlight = false;
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); }
      });
  }

  /* Purchase gate, WINDOW capture (registers before the switcher's guardSubmit —
     head-deferred script order): while a switch is mid-flight we return WITHOUT
     stopping so the switcher's guard can hold and replay; otherwise in byo mode we
     own the submit. Checkout enabled (data-apw-checkout, setting + fresh map) ->
     2-line add; not enabled -> block with a toast. Live DOM read at event time. */
  if (!window.__apwSubmitGate) {
    window.__apwSubmitGate = true;
    window.addEventListener('submit', function (e) {
      var fs = liveFs();
      if (!fs) return;
      var soloGate = fs.hasAttribute('data-apw-solo');
      var setPicked = fs.dataset.apwMode === 'byo';
      if (!setPicked && !soloGate) return;
      if (fs.dataset.selected !== 'bundle') return;
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (document.querySelector('[data-sibsw-stage]')) return; // mid-switch: guard replays later
      var info = fs.closest('.product__info-container');
      if (info && info.getAttribute('aria-busy') === 'true') return;
      if (!setPicked) {
        /* solo page, set tile chosen, no pouch picked yet: never add the bag alone */
        e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
        toast('Pick a pouch colour first \u2014 tap one of the dots.');
        ga('apw_add_blocked', { widget: 'byo', origin: 'no_match', reason: 'no_pick' });
        return;
      }
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      if (fs.dataset.apwCheckout === '1' && fs.dataset.apwPouchVariant) {
        apwAdd(fs, form);
      } else {
        toast('Mix & match checkout is almost ready — the ' + (fs.dataset.apwPouch || 'picked') + ' set will be addable soon.');
        ga('apw_add_blocked', { widget: 'byo', pouch_colorway: fs.dataset.apwPouch || '' });
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('soolla:product-swapped', init);
})();
